import {
  ChatBubbleLeftRightIcon,
  EnvelopeIcon,
} from '@heroicons/react/24/outline';
import dynamic from 'next/dynamic';

const Modal = dynamic(() => import('components/molecules/modal'));

type LeadSendMessageChoiceModalProps = {
  open: boolean;
  email?: string | null;
  phone?: string | null;
  onClose: () => void;
  onChooseEmail: () => void;
  onChooseSms: () => void;
};

export default function LeadSendMessageChoiceModal({
  open,
  email,
  phone,
  onClose,
  onChooseEmail,
  onChooseSms,
}: LeadSendMessageChoiceModalProps) {
  const hasEmail = Boolean(email?.trim());
  const hasPhone = Boolean(phone?.trim());

  return (
    <Modal
      open={open}
      small
      title="Send message"
      subTitle="Choose how you want to contact this lead"
      close={onClose}
    >
      <div className="grid gap-3 px-4 py-4 sm:grid-cols-2">
        <button
          type="button"
          disabled={!hasEmail}
          onClick={onChooseEmail}
          className="flex flex-col items-start rounded-lg border border-gray-200 bg-white p-4 text-left shadow-sm transition hover:border-teal-300 hover:bg-teal-50/40 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <EnvelopeIcon className="mb-2 h-6 w-6 text-teal-700" />
          <span className="text-sm font-semibold text-gray-900">Email</span>
          <span className="mt-1 text-xs text-gray-500">
            {hasEmail
              ? 'Compose in Missive with Admissions templates'
              : 'No email on this lead'}
          </span>
        </button>

        <button
          type="button"
          disabled={!hasPhone}
          onClick={onChooseSms}
          className="flex flex-col items-start rounded-lg border border-gray-200 bg-white p-4 text-left shadow-sm transition hover:border-purple-300 hover:bg-purple-50/40 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <ChatBubbleLeftRightIcon className="mb-2 h-6 w-6 text-purple-700" />
          <span className="text-sm font-semibold text-gray-900">SMS</span>
          <span className="mt-1 text-xs text-gray-500">
            {hasPhone
              ? 'Send a text message from Managed'
              : 'No phone number on this lead'}
          </span>
        </button>
      </div>
    </Modal>
  );
}
